module.exports = __webpack_public_path__ + "img/astral-txt_25.c8c8225c.svg";